var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rowDataValue)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_c('a',{attrs:{"href":_vm.urlGenerator(_vm.PRODUCT_DETAILS+'edit/'+_vm.rowDataValue.product_id)},on:{"click":_vm.handleProductNameClick}},[_vm._v(_vm._s(_vm.rowDataValue.name))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }